import './tournaments-logo';
import './tournaments-logo-compact';
